<template>
  <v-tabs-items v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </v-tabs-items>
</template>
<script>
export default {
  inheritAttrs: false
}
</script>
